import { sdkFactory as wixRiseV1GiftCard_sdkFactory_giftCard } from './src/rise-v1-gift-card.frontend';
import { sdkFactory as wixRiseV1Wallet_sdkFactory_wallet } from './src/rise-v1-wallet.frontend';
import { sdkFactory as wixRiseV1WalletAction_sdkFactory_walletAction } from './src/rise-v1-wallet-action.frontend';
export function sdkFactory(args) {
    return {
        giftCard: wixRiseV1GiftCard_sdkFactory_giftCard(args),
        wallet: wixRiseV1Wallet_sdkFactory_wallet(args),
        walletAction: wixRiseV1WalletAction_sdkFactory_walletAction(args),
    };
}
//# sourceMappingURL=index.frontend.js.map